var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99999L6.4393 7.03271C5.91026 6.59184 5.64574 6.37141 5.45557 6.10119C5.28708 5.86177 5.16195 5.59461 5.08589 5.31189C5.00004 4.99281 5.00004 4.64848 5.00004 3.95982V1.66666M10 9.99999L13.5608 7.03271C14.0898 6.59184 14.3543 6.37141 14.5445 6.10119C14.713 5.86177 14.8381 5.59461 14.9142 5.31189C15 4.99281 15 4.64848 15 3.95982V1.66666M10 9.99999L6.4393 12.9673C5.91026 13.4081 5.64574 13.6286 5.45557 13.8988C5.28708 14.1382 5.16195 14.4054 5.08589 14.6881C5.00004 15.0072 5.00004 15.3515 5.00004 16.0402V18.3333M10 9.99999L13.5608 12.9673C14.0898 13.4081 14.3543 13.6286 14.5445 13.8988C14.713 14.1382 14.8381 14.4054 14.9142 14.6881C15 15.0072 15 15.3515 15 16.0402V18.3333M3.33337 1.66666H16.6667M3.33337 18.3333H16.6667",
    stroke: "#F7FAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.369bc89403a8b2124743805f3676e222.svg";
export { ForwardRef as ReactComponent };